import React from 'react';
import { usePwaInstall } from '@/services/pwa/usePwaInstall';
import { Download, X, Terminal } from 'lucide-react';

export const PwaInstallBanner: React.FC = () => {
  const { canInstall, isStandalone, isDismissed, install, dismiss } = usePwaInstall();

  // Guard: Only render when install prompt is available and not dismissed or standalone
  if (!canInstall || isStandalone || isDismissed) {
    return null;
  }

  const handleInstallClick = async () => {
    await install();
  };

  return (
    <aside
      aria-label="Install App Prompt"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:w-[400px] z-50 animate-fade-in-up"
    >
      <div className="relative overflow-hidden rounded-xl border border-emerald-500/30 bg-[var(--bg-surface)]/95 backdrop-blur-xl p-4 shadow-2xl shadow-black/80 ring-1 ring-emerald-500/10">
        {/* Subtle accent glow line at top */}
        <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-emerald-500/0 via-emerald-400/60 to-emerald-500/0" />

        {/* Close 'X' button */}
        <button
          onClick={dismiss}
          aria-label="Close install banner"
          className="absolute top-3 right-3 p-1 rounded-lg text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[var(--bg-surface-elevated)] active:scale-95 transition-all"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex items-start gap-3.5 pr-6">
          <div className="flex-shrink-0 p-2.5 rounded-lg bg-emerald-950/80 border border-emerald-800/80 text-emerald-400 shadow-[0_0_12px_rgba(16,185,129,0.2)]">
            <Terminal className="w-5 h-5" />
          </div>

          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-semibold font-mono tracking-tight text-[var(--text-primary)]">
              Install Trading Dashboard
            </h3>
            <p className="mt-1 text-xs text-[var(--text-muted)] leading-relaxed">
              Get faster access from your home screen.
            </p>

            <div className="mt-3.5 flex items-center gap-2">
              <button
                onClick={handleInstallClick}
                className="flex-1 inline-flex items-center justify-center gap-1.5 px-3.5 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-mono font-medium shadow-[0_0_15px_rgba(16,185,129,0.25)] active:scale-95 transition-all duration-150"
              >
                <Download className="w-3.5 h-3.5" />
                <span>Install App</span>
              </button>
              <button
                onClick={dismiss}
                className="px-3.5 py-2 rounded-lg border border-[var(--border-default)] bg-[var(--bg-surface-elevated)] hover:bg-[var(--bg-surface-muted)] text-[var(--text-secondary)] hover:text-[var(--text-primary)] text-xs font-mono active:scale-95 transition-all duration-150"
              >
                Maybe Later
              </button>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};
